{
  "access": {
    "denied": "Доступ запрещён",
    "noPermission": "У вас нет прав для просмотра этой страницы"
  },
  "navigation": {
    "unsavedChanges": {
      "title": "Несохраненные изменения",
      "message": "У Вас есть несохраненные изменения. Вы уверены, что хотите покинуть страницу?",
      "stay": "Остаться",
      "leave": "Покинуть страницу",
      "discardMessage": "У Вас есть несохраненные изменения. Продолжить и потерять их?",
      "discard": "Продолжить без сохранения"
    }
  },
  "action": {
    "expand": "Развернуть",
    "collapse": "Свернуть",
    "create": "Создать",
    "selectAll": "Выбрать все",
    "deselectAll": "Очистить все",
    "back": "Назад",
    "start": "Старт",
    "import": "Импорт",
    "export": "Экспорт",
    "analyze": "Анализировать",
    "done": "Готово",
    "selectFile": "Выбрать файл",
    "selectFileToImport": "Выберите файл для импорта",
    "restart": "Рестарт",
    "stop": "Стоп",
    "logs": "Логи",
    "detail": "Подробнее",
    "backHome": "На главную",
    "action": "Действия",
    "cancel": "Отмена",
    "close": "Закрыть",
    "copy": "Копировать",
    "paste": "Вставить",
    "upload": "Загрузить",
    "load": "Загрузить",
    "ok": "Сохранить",
    "save": "Сохранить",
    "send": "Отправить",
    "saveAs": "Сохранить как",
    "saveAsNew": "Сохранить как новый",
    "rename": "Переименовать",
    "okAndAdd": "Сохранить и добавить",
    "delete": "Удалить",
    "restore": "Восстановить",
    "add": "Добавить",
    "update": "Обновить",
    "retry": "Повторить",
    "clone": "Клонировать",
    "show": "Показать",
    "play": "Запустить",
    "open": "Открыть",
    "edit": "Редактировать",
    "editPassword": "Редактировать пароль",
    "groupBy": "Группировать по",
    "select": "Выбрать",
    "apply": "Применить",
    "clear": "Очистить",
    "clearAll": "Очистить все",
    "reset": "Сбросить",
    "allow": "Разрешить",
    "disallow": "Запретить",
    "search": "Поиск",
    "enable": "Включить",
    "disable": "Выключить",
    "connect": "Соединиться",
    "disconnect": "Рассоединиться",
    "confirm": "Подтвердить",
    "showMore": "Развернуть",
    "showLess": "Скрыть",
    "deleteTitle": "Вы действительно хотите удалить элемент?",
    "deleteGroupTitle": "Вы действительно хотите удалить элементы?",
    "dependingElements": "Зависимые элементы: ",
    "successSaveMsg": "Сохранено",
    "successUpdateMsg": "Обновлено",
    "successDeleteMsg": "Удалено",
    "successDoneMsg": "Выполнено",
    "successStartMsg": "Запущено",
    "userUpdate": "Пользователь успешно обновлен",
    "editExpand": "Редактировать в отдельном окне",
    "format": "Форматировать",
    "deleteDepends": "Удалите зависимости элемента",
    "downloadExcelFile": "Скачать Excel файл",
    "yes": "Да",
    "no": "Нет",
    "areMissing": "отсутствуют",
    "yamlErrorMsg": "Неверный YAML формат",
    "relatedTabs": "Количество связанных табов",
    "addToComparison": "Добавить к сравнению",
    "addedToComparison": "Добавлено",
    "removeFromComparison": "Убрать из сравнения",
    "compare": "Сравнить",
    "continue": "Продолжить",
    "cleanUpComparison": "Очистить историю сравнения",
    "fullscreen": "На весь экран",
    "replace": "Заменить",
    "block": "Заблокировать",
    "blockUser": "Заблокировать пользователя",
    "unblockUser": "Разблокировать пользователя",
    "toUpdate": "Обновлять",
    "showSelected": "Показать выбранные",
    "test": "Тест",
    "center": "Центрировать"
  },
  "placeholders": {
    "search": "Поиск",
    "date": "Выберите дату",
    "dateRange": "Выберите даты",
    "select": "Выберите",
    "input": "Введите значение",
    "newTag": "Для создания нового тега нажмите Enter"
  },
  "text": {
    "elementsCount": "Количество элементов",
    "more": "ещё {{count}}",
    "success": "Успешно",
    "error": "Ошибка",
    "view": "Просмотр",
    "actions": "Действия",
    "copied": "Скопировано",
    "all": "Всё",
    "search": "Поиск",
    "selected": "Выбрано",
    "total": "Всего",
    "inDevelopment": "В разработке...",
    "notSet": "Не задано",
    "noData": "Нет данных",
    "noResults": "Ничего не найдено",
    "noResultsDescription": "Не удалось найти данные по текущим условиям. Попробуйте изменить фильтры или поисковый запрос.",
    "active": "Активно",
    "inactive": "Не активно",
    "blockedUser": "Заблокирован",
    "activeUser": "Активен",
    "expired": "Просрочен",
    "name": "Название",
    "value": "Значение",
    "readonly": "Только чтение",
    "newElement": "Новый элемент",
    "selectItem": "Выберите элемент конфигурации",
    "description": "Описание",
    "nothingFound": "Ничего не найдено",
    "today": "Сегодня",
    "further": "Далее",
    "later": "Позднее",
    "loading": "Загрузка...",
    "noAvailableActions": "Нет доступных действий",
    "menu": "Меню",
    "settings": "Настройки",
    "found": "Найдено",
    "hidden": "Скрытые",
    "position": {
      "title": "Позиция",
      "top": "Сверху",
      "bottom": "Снизу",
      "left": "Слева",
      "right": "Справа"
    },
    "interval": {
      "customPlaceholder": "Введите интервал: 30с",
      "off": "Выключено",
      "title": "Частота обновления",
      "seconds": {
        "one": "Каждую секунду",
        "few": "Каждые",
        "many": "Каждые",
        "other": "Каждые"
      },
      "minutes": {
        "one": "Каждую минуту",
        "few": "Каждые",
        "many": "Каждые",
        "other": "Каждые"
      },
      "hours": {
        "one": "Каждый час",
        "few": "Каждые",
        "many": "Каждые",
        "other": "Каждые"
      },
      "days": {
        "one": "Каждый день",
        "few": "Каждые",
        "many": "Каждые",
        "other": "Каждые"
      },
      "weeks": {
        "one": "Каждую неделю",
        "few": "Каждые",
        "many": "Каждые",
        "other": "Каждые"
      },
      "months": {
        "one": "Каждый месяц",
        "few": "Каждые",
        "many": "Каждые",
        "other": "Каждые"
      },
      "null": {
        "other": "Не выбрано"
      }
    },
    "range": {
      "filterTitle": "Выберите период",
      "clockTime": "Время",
      "invalidDateTime": "Проверьте дату и местное время. Конец не должен быть раньше начала.",
      "absoluteDate": "Точные даты",
      "customPlaceholder": "Введите период: 2ч, 4д",
      "title": "Диапазон",
      "absolute": "Абсолютный",
      "relative": "Относительный",
      "to": "До",
      "from": "От",
      "startTime": "Начало",
      "endTime": "Конец",
      "ago": "назад",
      "now": "Сейчас",
      "empty": "Не выбрано",
      "last": {
        "seconds": {
          "one": "Последнюю секунду",
          "few": "Последние",
          "many": "Последние",
          "other": "Последние"
        },
        "minutes": {
          "one": "Последнюю минуту",
          "few": "Последние",
          "many": "Последние",
          "other": "Последние"
        },
        "hours": {
          "one": "Последний час",
          "few": "Последние",
          "many": "Последние",
          "other": "Последние"
        },
        "days": {
          "one": "Последний день",
          "few": "Последние",
          "many": "Последние",
          "other": "Последние"
        },
        "weeks": {
          "one": "Последнюю неделю",
          "few": "Последние",
          "many": "Последние",
          "other": "Последние"
        },
        "months": {
          "one": "Последний месяц",
          "few": "Последние",
          "many": "Последние",
          "other": "Последние"
        }
      }
    }
  },
  "app": {
    "name": "PAMIR",
    "version": "Версия",
    "versions": "Версии сервисов",
    "appSettings": "Настройки приложения",
    "applicationError": {
      "oops": "Ой...",
      "somethingWentWrong": "Что-то пошло не так",
      "alreadyReported": "Мы уже в курсе проблемы и решим ее как можно быстрее. Спасибо за вашу терпимость.",
      "reloadPage": "Обновить страницу"
    },
    "storagePrefetch": {
      "loading": "Загрузка приложения",
      "errorTitle": "Не удалось загрузить приложение",
      "errorDescription": "Не удалось получить все необходимые данные. Повторите загрузку, чтобы продолжить работу.",
      "reloadPage": "Обновить страницу"
    },
    "backendUnavailable": {
      "title": "Сервис временно недоступен",
      "description": "Не удаётся связаться с API. Приложение обновится само, когда необходимые сервисы снова будут доступны.",
      "checking": "Проверяем подключение… попытка {{count}}",
      "recovered": "Подключение восстановлено",
      "recoveredDescription": "Необходимые сервисы снова отвечают. Приложение обновится автоматически.",
      "recoveredManualDescription": "Необходимые сервисы снова отвечают. Автоматическое обновление временно отключено, чтобы избежать цикла перезагрузки.",
      "reloadingIn": "Обновление через {{count}} с",
      "reloadManually": "Можно безопасно обновить приложение",
      "reloadNow": "Обновить сейчас"
    },
    "themeSettings": {
      "title": "Настройки темы",
      "elements": "Настройки визуальных элементов",
      "lightTheme": "Светлая тема",
      "darkTheme": "Темная тема",
      "systemTheme": "Системная тема"
    }
  },
  "citFilter": {
    "clone": "Клонировать ноду",
    "delete": "Удалить ноду"
  },
  "error": {
    "401": "Ошибка авторизации",
    "403": "Отказано в доступе",
    "404": "Не найдено",
    "500": "Ошибка сервера",
    "default": "Что-то пошло не так",
    "connectionBreak": "Обрыв соединения"
  },
  "universalModal": {
    "monacoDialogTitle": "Редактировать шаблон"
  },
  "ExpressionsValue": {
    "best": "По лучшему",
    "worst": " По худшему",
    "average": "По среднему",
    "percentile": "Перцентиль",
    "frequency": "По частоте"
  },
  "table": {
    "pagination": {
      "showTotal": "Всего элементов : {{total}}"
    },
    "selected": "Выбрано: {{selected}}",
    "selectOdd": "Выбрать нечётные",
    "selectEven": "Выбрать чётные"
  },
  "conflictMessage": {
    "relatedCis": "КЕ, используемые в связи:",
    "relatedLinks": "Количество связей:"
  },
  "sort": {
    "asc": "Возрастание",
    "desc": "Убывание"
  },
  "colorPicker": {
    "label": "Стандартные",
    "pickFromScreen": "Выбрать цвет с экрана"
  },
  "versions": {
    "frontendVersion": "Фронтенд:",
    "backendVersion": "Бэкенд:"
  },
  "datetime": {
    "year": "г.",
    "month": "м.",
    "day": "д.",
    "hour": "ч.",
    "minute": "мин.",
    "second": "с.",
    "sec": "сек.",
    "millisecond": "мс."
  },
  "theme": {
    "defaultRadius": "Радиус",
    "defaultPrimaryColor": "Основной цвет",
    "defaultPrimaryShade": "Основной оттенок"
  },
  "appUpdate": {
    "updateAvailable": "Необходимо обновить приложение",
    "check": "Проверить обновления",
    "noUpdates": "Нет доступных обновлений",
    "notRegistered": "Сервис обновлений не зарегистрирован",
    "offline": "Нет подключения к сети",
    "unavailable": "Сервис обновлений недоступен",
    "checkFailed": "Не удалось проверить обновления",
    "checking": "Проверка обновлений...",
    "downloading": "Загрузка обновления",
    "preparing": "Подготовка обновления",
    "reloading": "Обновляем...",
    "resetting": "Восстанавливаем кеш обновлений...",
    "resetFailed": "Не удалось сбросить кеш обновлений",
    "files": "{{count}} файлов"
  },
  "time": {
    "seconds": "{{count}} секунда",
    "seconds_plural": "{{count}} секунды",
    "seconds_many": "{{count}} секунд",
    "minutes": "{{count}} минута",
    "minutes_plural": "{{count}} минуты",
    "minutes_many": "{{count}} минут",
    "hours": "{{count}} час",
    "hours_plural": "{{count}} часа",
    "hours_many": "{{count}} часов",
    "days": "{{count}} день",
    "days_plural": "{{count}} дня",
    "days_many": "{{count}} дней",
    "weeks": "{{count}} неделя",
    "weeks_plural": "{{count}} недели",
    "weeks_many": "{{count}} недель",
    "months": "{{count}} месяц",
    "months_plural": "{{count}} месяца",
    "months_many": "{{count}} месяцев"
  },
  "tableSelectors": {
    "selectAll": "Выбрать все",
    "selectOdd": "Выбрать нечётные",
    "selectEven": "Выбрать чётные",
    "invert": "Инвертировать выбор",
    "unselect": "Снять выделение"
  },
  "graphRenderer": {
    "export": {
      "viewport": "Экспорт видимой области",
      "graph": "Экспорт графа",
      "json": "Экспорт JSON"
    },
    "action": {
      "recenter": "Центрировать"
    }
  }
}